// Porta das rotas /squads/*: quem não tem acesso volta para o dashboard em vez
// de abrir a tela. A Estruturação vive no navegador, então esta é a única
// barreira — não há endpoint para barrar no backend.

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-hook';
import { podeAcessarEstruturacao } from './estruturacao-acesso';

export function EstruturacaoRoute({ children }: { children: ReactNode }) {
  // Enquanto a sessão não resolveu, o squad ainda é desconhecido — redirecionar
  // aqui expulsaria quem tem acesso.
  const { user, isAdmin, loading } = useAuth();

  if (loading) return null;
  if (!podeAcessarEstruturacao(user?.squadNome, isAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
